import {useApplications} from '@/hooks/useApplications'
import {useJourneyMetaConfig} from '@/hooks/useJourneyMetaConfig'
import {store} from '@/store'
import {selectApplication, selectMarket, selectShellActive} from '@/store/slices/commonSlice'
import {setJourneyMeta} from '@ReduxActions'
import {useEffect, useMemo} from 'react'
import {useSelector} from 'react-redux'

export const useCountries = () => {
  const shellActive = useSelector(selectShellActive)
  const market = useSelector(selectMarket)
  const application = useSelector(selectApplication)
  const {
    applications,
    isSuccess: isApplicationsLoaded,
    isLoading: isApplicationsLoading,
    isFetching: isApplicationsFetching,
    isError: isApplicationsError,
    error: applicationsError,
    refetch: refetchApplications,
  } = useApplications()

  const countries = useMemo(() => {
    const selectedApplication = applications.find(item => item.code === application)
    return isApplicationsLoaded && selectedApplication ? selectedApplication.countries.map(country => country.code) : []
  }, [applications, application, isApplicationsLoaded])

  const {country} = useJourneyMetaConfig()

  useEffect(() => {
    if (shellActive) {
      if (market && country !== market) {
        store.dispatch(setJourneyMeta({country: market}))
      }
      return
    }

    if (country && countries.includes(country)) {
      return
    }

    if (!countries.length) {
      if (country) {
        store.dispatch(setJourneyMeta({country: ''}))
      }
      return
    }

    store.dispatch(setJourneyMeta({country: countries[0]}))
  }, [countries, country, market, shellActive])

  return {
    countries,
    country,
    isLoading: isApplicationsLoading,
    isFetching: isApplicationsFetching,
    isError: isApplicationsError,
    error: applicationsError,
    refetch: refetchApplications,
  }
}
